import React, { useCallback, useRef } from 'react'
import { useTerritoryList } from '../../../modules/domain/territory/hooks'
import { TerritoryListRequestFilter } from '../../../modules/domain/territory/types'
import { useAction } from '@agro-club/frontend-shared'
import TerritoryActions from '../../../modules/domain/territory/duck'
import { useSelector } from 'react-redux'
import TerritorySelectors from '../../../modules/domain/territory/selectors'
import type { SelectProps, RefSelectProps } from 'antd'
import { useDebouncedCallback } from 'use-debounce'
import GenericSelect from '../Generics/GenericSelect'

type TerritorySelectProps = {
  onChange: SelectProps['onChange']
  placeholder: string
  title: string
}

const AntDTerritorySelect: React.FC<TerritorySelectProps> = ({ onChange, placeholder, title }) => {
  const [, dbTerritories] = useTerritoryList()
  const territoryFilterUpdated = useAction(TerritoryActions.filterUpdated)
  const territoryFilter = useSelector(TerritorySelectors.filter)
  const selectRef = useRef<RefSelectProps>(null)
  const territorySelectItems = dbTerritories?.map((territory) => {
    return {
      value: territory.id,
      label: territory.title,
    }
  })

  const debouncedCallback = useDebouncedCallback(
    (value: string) => {
      if (value.length > 3) {
        handleTerritoryFilterChange({ title: value })
      }
      if (value.length === 0) {
        handleTerritoryFilterChange({ title: undefined })
      }
    },
    300,
    {
      trailing: true,
      maxWait: 400,
    },
  )

  const handleTerritoryFilterChange = useCallback(
    (newFilterValue: Partial<TerritoryListRequestFilter>) => {
      territoryFilterUpdated({ ...territoryFilter, ...newFilterValue })
    },
    [territoryFilter, territoryFilterUpdated],
  )

  const handleOnChange: SelectProps['onChange'] = (value, option) => {
    if (selectRef.current) {
      selectRef.current.blur()
    }
    if (onChange) {
      onChange(value, option)
    }
  }
  return (
    <GenericSelect
      ref={selectRef}
      mode="multiple"
      maxCount={1}
      filterOption={false}
      placeholder={placeholder}
      title={title}
      options={territorySelectItems}
      onChange={handleOnChange}
      onSearch={debouncedCallback}
    />
  )
}

export default AntDTerritorySelect
